/** 🇬🇧 英语 */
export const EN = "en-US";
/** 🇨🇳 中文简体 */
export const ZH = "zh-CN";
/** 🇨🇳 中文繁体 */
export const TW = "zh-TW";
/** 🇧🇬 保加利亚语 */
export const BG = "bg";
/** 🇨🇿 捷克语 */
export const CS = "cs";
/** 🇩🇪 德语 */
export const DE = "de";
/** 🇪🇸 西班牙语 */
export const ES = "es";
/** 🇫🇷 法语 */
export const FR = "fr";
/** 🇫🇮 芬兰语 */
export const FI = "fi";
/** 🇮🇹 意大利语 */
export const IT = "it";
/** 🇮🇩 印度尼西亚语 */
export const ID = "id";
/** 🇯🇵 日语 */
export const JA = "ja";
/** 🇰🇷 韩国语 */
export const KO = "ko";
/** 🇳🇱 荷兰语 */
export const NL = "nl";
/** 🇳🇴 挪威书面语 */
export const NO = "nb-NO";
/** 🇷🇺 俄语 */
export const RU = "ru";
/** 🇸🇪 瑞典语 */
export const SV = "sv";
/** 🇵🇹 葡萄牙语 */
export const PT = "pt";
/** 🇸🇦 阿拉伯语 */
export const AR = "ar";
/** 🇹🇭 泰语 */
export const TH = "th";
/** 🇷🇴 罗马尼亚 */
export const RO = "ro";
/** 🇻🇳 越南语 */
export const VI = "vi";
/** 维吾尔语 */
export const UG = "ug";
/** 马来西亚语 */
export const MS = "ms-MY";

export const I18NList = [
  {
    code: EN,
    iso: EN,
    name: "English",
  },
  // {
  //   code: TW,
  //   iso: TW,
  //   name: "繁體中文",
  // },
  {
    code: ZH,
    iso: ZH,
    name: "简体中文",
  },
  // {
  //   code: BG,
  //   iso: BG,
  //   name: "български",
  // },
  // {
  //   code: CS,
  //   iso: CS,
  //   name: "Čeština",
  // },
  // {
  //   code: DE,
  //   iso: DE,
  //   name: "Deutsch",
  // },
  {
    code: ES,
    iso: ES,
    name: "Español",
  },
  // {
  //   code: FR,
  //   iso: FR,
  //   name: "Français",
  // },
  // {
  //   code: FI,
  //   iso: FI,
  //   name: "Suomi",
  // },
  // {
  //   code: IT,
  //   iso: IT,
  //   name: "Italiano",
  // },
  // {
  //   code: ID,
  //   iso: ID,
  //   name: "Bahasa Indonesia",
  // },
  // {
  //   code: JA,
  //   iso: JA,
  //   name: "日本語",
  // },
  // {
  //   code: KO,
  //   iso: KO,
  //   name: "한국어",
  // },
  // {
  //   code: NL,
  //   iso: NL,
  //   name: "Nederlands",
  // },
  // {
  //   code: NO,
  //   iso: NO,
  //   name: "Norsk",
  // },
  // {
  //   code: RU,
  //   iso: RU,
  //   name: "Русский",
  // },
  // {
  //   code: SV,
  //   iso: SV,
  //   name: "Svenska",
  // },
  {
    code: PT,
    iso: PT,
    name: "Português",
  },
  // {
  //   code: AR,
  //   iso: AR,
  //   name: "العربية",
  // },
  // {
  //   code: TH,
  //   iso: TH,
  //   name: "ภาษาไทย",
  // },
  // {
  //   code: RO,
  //   iso: RO,
  //   name: "Română",
  // },
  // {
  //   code: VI,
  //   iso: VI,
  //   name: "Tiếng Việt",
  // },
  // {
  //   code: UG,
  //   iso: UG,
  //   name: "ئۇيغۇرچە",
  // },
  // {
  //   code: MS,
  //   iso: MS,
  //   name: "Bahasa Melayu",
  // },
];

export const supportLangCodes = I18NList.map((item) => item.code);
